import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { RefreshCw, XSquare } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTooltip from 'react-tooltip';
import { DropdownItem } from 'reactstrap';
import AuthenticateChildren from '../../AuthenticateChildren';
import auth from '../../AuthService';
import BackButton from '../../components/BackButton';
import { FloatingCheckbox } from '../../components/FloatingPlaceholder';
import { inIframe } from '../../components/Layout';
import { Loader } from '../../components/Loader';
import { NotFound } from '../../components/NotFound';
import OptionsButton from '../../components/OptionsButton';
import { PTErrors, PTInputSelect, PTInputText } from '../../components/PTElements';
import { SubmitButton } from '../../components/SubmitButton';
import { activePatientSyncMonths, initialSync_Status, patientIntakeFormFormat, roles, timeZones } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from '../../redux/clients';
import { urls } from '../../urls';
import cx from 'classnames';
import ClientChores from './ClientChores';
import './ClientDetailsBasic.css';
import { ClientSmsCredit } from './ClientSmsCredit';

const CD = props => {
    const [displayed, setDisplayed] = useState(false);
    const [newKey, setNewKey] = useState(false);
    const [currentActivePatientSyncMonths, setCurrentActivePatientSyncMonths] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const id = EVO.getParamsId(props);
        if (id) {
            if (id === 'main') {
                props.fetchMainClientDetails().then(r => setLoading(false));
            }
            else if (id === 'new') {
                props.fetchclients(props);
                setLoading(false);
            }
            else {
                props.fetchClientDetails(id).then(r => setLoading(false));
            }
        }

    }, []);

    useEffect(() => {
        if (props && props.client && props.client.id) {
            if (!displayed) {
                setDisplayed(true);
                if (!props.client.maskedClinikoApiKey || props.client.invalidClinikoApiKey) {
                    EVO.error('Cliniko API key not supplied or invalid');
                }
            }
        }

        EVO.updateIdFromNew(props, props.client, urls.router.clients.index.url);
    }, [props.id]);

    useEffect(() => {
        if (!EVO.isEmptyObject(props.monthlyLimits)) {
            var arr = [];
            activePatientSyncMonths.forEach(a => {
                const month = a.value || 0;
                const count = props.monthlyLimits[`${month}`];
                if (count) {
                    arr.push({ label: a.label + ` (${count})`, value: a.value });
                }
                else {
                    arr.push({ label: a.label, value: a.value });
                }
            });

            if (props.client && props.client.activePatientSyncMonths !== -1) {
                // Not in a trial, so remove that options
                arr = arr.filter(a => a.value !== -1);
            }

            setCurrentActivePatientSyncMonths(arr);
        }
        else {
            setCurrentActivePatientSyncMonths(activePatientSyncMonths);
        }

    }, [props.monthlyLimits, props.id, props.client]);

    const save = (values, setSubmitting) => {
        props.addOrUpdateItem(values)
            .finally(() => {
                setSubmitting(false);
            });
    };

    const contextDelete = () => {
        if (window.confirm('Are you sure you want to delete this item?')) {
            props.deleteClientFromPT(props.id).then(() => {
                props.history.push(urls.router.clients.index.url);
            });
        }
    };

    const runSync = (data) => {
        if (window.confirm('Are you sure you want to sync this client? It is a long running background process')) {
            data.id = props.id;
            props.runSync(data);
        }
    };

    const renderDetails = () => {
        return props.client.isCmClient && props.client.hasTransactional ? <ClientChores /> : null;
    };

    const handleTagDeletion = option => {
        if (!EVO.any(props.client.chores)) {
            return true;
        }

        const chores = props.client.chores.filter(c => c.choreTypeId === 1 && c.cmEmailId && EVO.any(c.tags, t => t === option.value));
        if (EVO.any(chores)) {
            EVO.alert(`Sorry, you cannot remove a modality until you turn off all transactional emails associated to it`);
            return false
        }

        return true;
    };

    const validate = (values) => {
        const errors = {};
        if (values.smsName) {
            if (!/^\d*[a-z][a-z0-9 ]*$/i.test(values.smsName)) {
                errors.smsName = 'Invalid SMS Sender Name: Accepted characters include both upper- and lower-case ASCII letters, the digits 0 through 9, and space: A-Z, a-z, 0-9. They may not be only numbers';
            }
        }

        return errors;
    }

    return (
        <div>
            <Loader loading={loading || (props.loadingDetails && props.client)}>
                {!inIframe() && <BackButton />}
                <NotFound found={!loading && props.client && !props.loadingDetails && !props.loading}>
                    <AuthenticateChildren roles={[roles.Admin]}>
                        <OptionsButton>
                            <DropdownItem onClick={() => contextDelete()}><XSquare />  Delete</DropdownItem>
                            <DropdownItem onClick={() => runSync({ skipCliniko: false })}><RefreshCw />  Full Sync From Cliniko to CM</DropdownItem>
                            <DropdownItem onClick={() => runSync({ skipCliniko: true })}><RefreshCw />  Sync Client To CM</DropdownItem>
                            <DropdownItem onClick={() => runSync({ skipCliniko: true, resetCurrentSyncJob: true })}><RefreshCw />  Reset sync job status</DropdownItem>
                            <DropdownItem onClick={() => runSync({ skipCliniko: true, resetCurrentSyncJob: true, forceSync: true })}><RefreshCw />  Force Sync To CM</DropdownItem>
                        </OptionsButton>
                    </AuthenticateChildren>
                    {props.client && props.client.id && !props.client.onboarded && <div className="cdb-onboarding-message"><span role="img" aria-label="alarm">⏰</span> Your account is now being specially set up by the team. This process can take up to 3 business days. We will send you an email as soon as your customised account is ready</div>}
                    {props.client && props.client.id && props.client.invalidClinikoApiKey && <div className="cdb-onboarding-message">
                        <span role="img" aria-label="stop">✋</span>
                        <span> Your API key is invalid. It may have been entered incorrectly, deleted from Cliniko or expired. Please generate a new one and enter it below for Peptalkr to continue to work correctly. <a href="https://help.cliniko.com/en/articles/1023957-generate-a-cliniko-api-key" target="_blank" rel="noopener noreferrer">Click here for details on how to do this</a></span>
                    </div>}
                    <Formik
                        initialValues={props.client}
                        enableReinitialize={true}
                        validate={(values) => validate(values)}
                        onSubmit={(values, { setSubmitting }) => save(values, setSubmitting)}>
                        {({ isSubmitting, values }) => (
                            <Form>
                                <ReactTooltip />
                                <div className="cdb-details">
                                    <Detail title="Primary Business Name" subtitle="The main name your groups of businesses goes by" required={true}>
                                        <Field type="text" name="name" component={PTInputText} left="true"/>
                                    </Detail>
                                    <Detail title="Timezone" subtitle="Send and schedule your email & SMS in local time" required={true}>
                                        <Field name="timeZone" component={PTInputSelect} options={EVO.getSelectItemFromSingularArray(timeZones)} placeholder="Time zone" isSearchable={true} left="true" />
                                    </Detail>
                                    <Detail title="Your Cliniko API Key" required={true}
                                        subtitle={<span>Login to Cliniko as a Practitioner who is also an Administrator and follow <a href="https://help.cliniko.com/en/articles/1023957-generate-a-cliniko-api-key" target="_blank" rel="noopener noreferrer">these steps</a> (👈The Practitioner part is really important! If you're not logged in as a Practitioner some features will not work).</span>}>
                                        {props.client.maskedClinikoApiKey && !newKey ?
                                            <Field type="text" name="maskedClinikoApiKey" component={PTInputText} disabled={true} left="true">
                                                {props.client.maskedClinikoApiKey &&
                                                    <span className="cdb-newapi" onClick={() => setNewKey(true)}>Enter new API key</span>}
                                            </Field> :
                                            <Field type="text" name="newClinikoApiKey" component={PTInputText} left="true">
                                            </Field>}
                                        {newKey && <div className="cdb-cancel-wrapper" >
                                            <span>Enter your new API Key above</span>
                                            <span className="cdb-cancel" onClick={() => setNewKey(false)}>Cancel</span>
                                        </div>}
                                    </Detail>
                                    <Detail title="Active Patient Limit" required={true}
                                        subtitle="Please select the maximum number of months since the patient's last visit that you'd like to import into your email marketing. We do not import inactive or deleted patients">
                                        {props.client.canChangeSyncMonths ? <Field name="activePatientSyncMonths" component={PTInputSelect} options={currentActivePatientSyncMonths} left="true" placeholder={null} /> :
                                            <span>You are currently in free trial mode. You will be limited to a max of 250 patients in your marketing list until it ends. You can end your free trial early by chatting with us.</span>}
                                        <div className="cdb-marketing-wrapper">
                                            <Field name="onlySyncToMarketingIfOptedInCliniko" component={FloatingCheckbox}
                                                placeholder={<span>Only sync patients to my email marketing list if they are opted in for email marketing in Cliniko </span>}
                                                info={"When a new patient is added to Cliniko they are opted out by default. Ticking this will ensure the patient has expressly been opted in in order to be in your email marketing list. Leave this unchecked if you want to import everyone. They will then have the option to unsubcribe from the first marketing email you send them. This setting does not apply to transactional email."} />
                                        </div>
                                    </Detail>
                                    <Detail title="Online booking link"
                                        subtitle="This is handy if you're sending recalls and want patients to be able to book in themselves online. It should look something like this: https://yourbusiness.cliniko.com/bookings/">
                                        <Field type="text" name="bookingLinkUrl" component={PTInputText} left="true" />
                                    </Detail>
                                    <Detail title="Reception email"
                                        subtitle="We’ll forward replies to any of the emails you send with Peptalkr here. You can also change or disable the reply-to email address on the individual mailings you send">
                                        <Field type="text" name="receptionEmailAddress" component={PTInputText} left="true" />
                                    </Detail>
                                    {!values.hideSmsName &&
                                        <Detail title="Custom SMS Sender Name"
                                        subtitle={<span>If your recipient is located in a country that accepts Alphanumeric sender IDs, you can set an 11 character SMS Sender name here. <strong>We strongly recommend</strong> you <a href="http://help.peptalkr.com.au/en/articles/7843256-sending-sms-important-information" target="_blank" rel="noopener noreferrer">click here</a> to read more about this before enabling SMS.</span>}>
                                            <Field type="text" name="smsName" component={PTInputText} left="true" maxlength={11} />
                                            <PTErrors fields={['smsName']} />
                                        </Detail>}
                                    <Detail title="Mobile Contact Number" subtitle="This phone number will be used when sending yourself test SMS. We may also use it to send you notifications if there is an urgent issue with your account">
                                        <Field type="text" name="mobileContactNumber" component={PTInputText} left="true" maxlength={15} />
                                    </Detail>
                                    <Detail title="Communication Log" disableFlex
                                        subtitle={<span>Turn this on if you'd like us to leave a record of every SMS and transactional email we send to a patient in the patient file. Records will be prepended to the 'Other Information' field. It will not overwrite or interfere with other text you add in that field. <a href="http://help.peptalkr.com.au/en/articles/4988521-communication-log" target="_blank" rel="noopener noreferrer">More info</a></span>}>
                                        <Field name="addLogToPatientNotes" component={FloatingCheckbox} placeholder="Enable for SMS and Transactional Email" />
                                    </Detail>
                                    <Detail title="Patient Intake Form Settings" disableFlex
                                        subtitle={<span>The Peptalkr patient intake form automatically syncs patient information into Cliniko. Any extra questions asked are saved as a treatment note, or as an attachment, in the patient file. <a href="https://help.peptalkr.com.au/en/collections/1925159-forms" target="_blank" rel="noopener noreferrer">More info</a></span>}>
                                        <Field name="patientIntakeFormFormat" component={PTInputSelect} options={EVO.getSelectItemFromObjectOfSelectItems(patientIntakeFormFormat)} placeholder="How to process the intake form" left="true" />
                                        {values.patientIntakeFormFormat === patientIntakeFormFormat.PatientNotes.value && <Field name="treatmentNotesPublish" component={FloatingCheckbox} placeholder="Save treatment notes as published instead of a draft" />}
                                    </Detail>
                                    <AuthenticateChildren roles={[roles.Admin]}>
                                        <Detail title="Owner Name" subtitle="The name of the primary account holder">
                                            <Field type="text" name="ownerName" component={PTInputText} left="true"
                                                disabled={!auth.getInstance().userInRoles([roles.Admin, roles.Owner])} />
                                        </Detail>
                                        <Detail title="Email Address" subtitle="The email address of the primary account holder">
                                            <Field type="text" name="emailAddress" component={PTInputText} left="true"
                                                disabled={!auth.getInstance().userInRoles([roles.Admin, roles.Owner])} />
                                        </Detail>
                                        <Detail title="Short Name" subtitle="The WordPress user ID associated with the client">
                                            <Field type="text" name="shortName" component={PTInputText} disabled={props.client.id} left="true" />
                                        </Detail>
                                        <Detail title="Auth0 UserId" subtitle="The Auth0 User ID associated to this client">
                                            <Field name="userId" component={PTInputText} left="true" />
                                        </Detail>
                                        <Detail title="Intake Form Url">
                                            <Field type="text" name="intakeFormUrl" component={PTInputText} left="true" />
                                        </Detail>
                                        <Detail title="Feedback Form Url">
                                            <Field type="text" name="feedbackFormUrl" component={PTInputText} left="true" />
                                        </Detail>
                                        {(values.cmExistingClient || props.client.cmClientId) &&
                                            <Detail title="CM API Key">
                                            <Field type="text" name="cmApiKey" component={PTInputText} left="true" />
                                            </Detail>}
                                        {(values.cmExistingClient || props.client.cmClientId) &&
                                            <Detail title="CM Client Id">
                                            <Field type="text" name="cmClientId" component={PTInputText} left="true" />
                                            </Detail>}
                                        <Detail title="" subtitle="">
                                            <div>
                                                {(!props.loadingDetails || !props.client.cmClientId) && <Field name="isPremium" component={FloatingCheckbox} placeholder="Is Premium account" info="If the user signed up for a ‘Lite’ plan, leave this unticked" />}
                                                </div><div>
                                                {!props.client.cmClientId && <Field name="cmExistingClient" component={FloatingCheckbox} placeholder="Is Existing Peptalkr/CM Client?" />}
                                                </div><div>
                                                <Field name="onboarded" component={FloatingCheckbox} placeholder="Onboarded" /><br />
                                                <Field name="whiteLabel" component={FloatingCheckbox} placeholder="White Label" />
                                            </div>
                                            <div>
                                            {(!props.loadingDetails || !props.client.cmClientId) && <Field name="disableEmailReminderCheck" component={FloatingCheckbox}
                                                    placeholder="Disable Email Reminder Check" info="If true, then it doesn't check against 'reminder_type' for email." />}
                                            </div>

                                            <div>
                                                {(!props.loadingDetails || !props.client.cmClientId) && <Field name="suspended" component={FloatingCheckbox}
                                                    placeholder="Suspended" info="Suspends a client" />}
                                            </div>
                                        </Detail>
                                        {values.activePatientSyncMonths === -1 &&
                                            <Detail title="Trial End Date">
                                            <Field name="trialEndDate" component={PTInputText} left="true" type="datetime-local" />
                                            </Detail>}
                                        <Detail title="Twilio SID">
                                            <Field name="twilioSid" component={PTInputText} left="true" />
                                        </Detail>
                                        <Detail title="SMS Sender Settings" disableFlex>
                                            <Field name="smsSendFromParentSender" component={FloatingCheckbox} placeholder="Disable Twilio Subaccount" />
                                            <Field name="smsSendFromPooledNumber" component={FloatingCheckbox} placeholder="Send SMS from Pooled Number" />
                                        </Detail>
                                    </AuthenticateChildren>
                                    {EVO.any(props.allTags) && <Detail title="Which modalities do you offer in your clinic?"
                                        subtitle="This helps up to better customise your account to your specific treatment offerings"><div>
                                            <Field name="tags"
                                                component={PTInputSelect}
                                                onRemove={handleTagDeletion}
                                                options={EVO.getSelectItemFromObject(props.allTags, p => p, p => p)}
                                                isMulti={true} />
                                        </div></Detail>}
                                </div>
                                <div className="cdb-detail-button-wrapper">
                                    <SubmitButton type="submit" disabled={isSubmitting} classNames={{ 'loading': isSubmitting }} text="Save" />
                                </div>
                                <AuthenticateChildren roles={[roles.Admin]}>
                                    {props.client.isCmClient && <div className="sync-status">
                                        <div className={`sync-status-${props.client.initialSyncStatus}`}>Initial Sync Status: <span>{EVO.getPropertyNameFromValue(initialSync_Status, props.client.initialSyncStatus)}</span></div>
                                        {EVO.canBeZero(props.client.initialSyncCount) &&
                                            props.client.initialSyncStatus === initialSync_Status.Completed &&
                                            <div>Patients synced to CM in Initial Sync: {props.client.initialSyncCount}</div>}
                                        {EVO.canBeZero(props.client.activePatients) &&
                                            props.client.initialSyncStatus === initialSync_Status.Completed &&
                                            <div>Total patients in database: {props.client.activePatients}</div>}
                                        {EVO.canBeZero(props.client.activePatientsInCm) &&
                                            props.client.initialSyncStatus === initialSync_Status.Completed &&
                                            <div>Current patients in CM: {props.client.activePatientsInCm}</div>}
                                    </div>}
                                </AuthenticateChildren>
                                {renderDetails()}
                            </Form>
                        )}
                    </Formik>

                    <AuthenticateChildren roles={[roles.Admin]}>
                        <ClientSmsCredit />
                    </AuthenticateChildren>
                </NotFound>
            </Loader>
        </div>
    );
};

const Detail = ({ title, subtitle, children, required, ...props }) => {
    if (!children) {
        return null;
    }

    return <div className="cdb-detail">
        {title && <div className="cdb-detail-title">{title} {required && <span className="cdb-detail-required">*</span>}</div>}
        {subtitle && <div className={cx("cdb-detail-subtitle", {
            'cdb-detail-subtitle-disable-flex': props.disableFlex
        })}>{subtitle}</div>}
        {<div className="cdb-detail-field">{children}</div>}
    </div>;
};

const mapStateToProps = ({ clients }) => ({
    client: clients.client,
    loading: clients.loading,
    timezones: clients.timezones,
    allTags: clients.allTags,
    loadingDetails: clients.loadingDetails,
    error: clients.error,
    id: clients.id,
    monthlyLimits: clients.monthlyLimits
});

export default connect(mapStateToProps, actions)(withRouter(CD));


// WEBPACK FOOTER //
// ./src/pages/Clients/ClientDetailsBasic.js